export const isFullscreen = (getters) => {
  return getters.fullscreen
}
